/*
  Clark Tanks - Expivi preset preload config.

  Preset resolution order (implemented in expivi-modal.js):
    1) presetBySku[<SKU>]      EXCEPTIONS only -> many Shopify SKUs share ONE Expivi preset
    2) deriveBasePresetSku()   DEFAULT 1:1 -> the Expivi preset identifier == the product base SKU
                               (trailing letter suffix like -FT / -TP stripped)
    3) products[<id>].preset   legacy per-product fallback

  MOST products are 1:1 and need NO entry here (their base SKU is the preset identifier in Expivi).
  Only list MANY-TO-ONE exceptions below: each SKU -> the shared preset identifier.

  NOTE (2026-07-22): first mapped product is "13600L Round Tank" (id 10750803870033, SKU CT3000),
  connected in the Expivi app to configurable 25780. If an Expivi preset named "CT3000" does not
  exist yet, the modal still opens on the catalogue default — create the preset to auto-load its config.
*/
window.ClarkExpiviConfig = {
  // many-to-one overrides (SKU -> shared Expivi preset identifier)
  presetBySku: {
    // "CT3000-TP": "CT3000",  // e.g. a pump-bundle SKU that should load the base CT3000 preset
  },
  // legacy per-product fallback (used only when a product has no SKU and no override)
  products: {
    // 10750803870033: { preset: "CT3000" }  // 13600L Round Tank — SKU==preset, no entry needed
    // Unlisted duplicate of the 22700L used to test add-to-cart without exposing customers.
    // SKUs are locked in this store, so the copy has none; point it at the 22700L preset.
    11152081944913: { preset: "CT5000" }     // 22700L Round Tank (TEST)
  }
};
